import React from 'react';
import { Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const ExcelExportButton = ({ customer, devices, serviceHistory, communicationLog, balance }) => {

    const handleExport = () => {
        if (!customer) return;

        const wb = XLSX.utils.book_new();

        // 1. ÖZET SAYFASI
        const summaryData = [
            ["Müşteri Bilgileri", ""],
            ["Adı Soyadı", customer.adSoyad],
            ["Telefon", customer.telefon || '-'],
            ["E-posta", customer.email || '-'],
            ["Adres", customer.adres || '-'],
            ["Hizmet Türü", customer.hizmetTuru || '-'],
            ["", ""],
            ["Finansal Durum", ""],
            ["Güncel Bakiye", balance ? `${balance.toLocaleString('tr-TR')} ₺` : '0 ₺'],
            ["", ""],
            ["Rapor Tarihi", format(new Date(), 'dd.MM.yyyy HH:mm', { locale: tr })]
        ];
        const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
        // Sütun genişlikleri
        wsSummary['!cols'] = [{ wch: 20 }, { wch: 40 }];
        XLSX.utils.book_append_sheet(wb, wsSummary, "Özet");

        // 2. CİHAZLAR SAYFASI
        const devicesData = devices.map(d => ({
            "Seri Numarası": d.seriNumarasi,
            "Marka": d.marka,
            "Model": d.model,
            "Ekleme Tarihi": d.eklenmeTarihi?.toDate ? format(d.eklenmeTarihi.toDate(), 'dd.MM.yyyy', { locale: tr }) : '-'
        }));
        const wsDevices = XLSX.utils.json_to_sheet(devicesData.length > 0 ? devicesData : [{ "Bilgi": "Kayıtlı cihaz yok" }]);
        wsDevices['!cols'] = [{ wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
        XLSX.utils.book_append_sheet(wb, wsDevices, "Cihazlar");

        // 3. SERVİS GEÇMİŞİ SAYFASI
        const servicesData = serviceHistory.map(s => ({
            "Servis No": s.cihazSeriNumarasi ? `#${s.cihazSeriNumarasi}` : '-',
            "Durum": s.durum,
            "Tarih": s.olusturmaTarihi?.toDate ? format(s.olusturmaTarihi.toDate(), 'dd.MM.yyyy', { locale: tr }) : '-',
            "Toplam Tutar": s.toplamTutar,
            "Ödenen": s.odenenTutar
        }));
        const wsServices = XLSX.utils.json_to_sheet(servicesData.length > 0 ? servicesData : [{ "Bilgi": "Servis kaydı yok" }]);
        XLSX.utils.book_append_sheet(wb, wsServices, "Servis Geçmişi");

        // Dosyayı İndir
        XLSX.writeFile(wb, `${customer.adSoyad}_Detay_Raporu.xlsx`);
    };

    return (
        <Button
            variant="outlined"
            color="success"
            startIcon={<FileDownloadIcon />}
            onClick={handleExport}
        >
            Excel İndir
        </Button>
    );
};

export default ExcelExportButton;
